export enum MessageHubGroup {
    AlertUserGroup = 'AlertUserGroup',
    AppointmentGridGroup = 'AppointmentGridGroup',
    CentralAppointmentGridGroup = 'CentralAppointmentGridGroup',
    CentralBranchGridGroup = 'CentralBranchGridGroup',
    CentralLobbyEntryGridGroup = 'CentralLobbyEntryGridGroup',
    CentralStaffStatusGridGroup = 'CentralStaffStatusGridGroup',
    LobbyEntryGridGroup = 'LobbyEntryGridGroup',
    SignInUsersGroup = 'SignInUsersGroup',
    StaffStatusGridGroup = 'StaffStatusGridGroup',
    StatBarGroup = 'StatBarGroup',
    UserStatusGroup = 'UserStatusGroup',
    SystemConfigurationGroup = 'SystemConfigurationGroup',
    LocationSelectorStatusGroup = 'LocationSelectorStatusGroup',
    ClientCreateGroup = "ClientCreateGroup",
    SyncGroup = "SyncGroup",
    AppointmentWaitCountByLocationGroup = "AppointmentWaitCountByLocationGroup",
    LobbyEntryWaitCountByLocationGroup = "LobbyEntryWaitCountByLocationGroup",
    DataImportGroup = "DataImportGroup"
}


